import { defineStore } from 'pinia'
import axiosOverlayConnector from '@/services/axiosOverlayConnector.js'
import useUserStore from '@/stores/user.js'

export default defineStore('recurrence', {
  state: () => ({
    recurrences: null,
    loading: 0
  }),

  getters: {
    isLoading: (state) => {
      return state.loading > 0
    }
  },

  actions: {
    handleName(id) {
      switch (id) {
        case 'journaliere':
          return 'Journalière'
        case 'hebdomadaire':
          return 'Hebdomadaire'
        case 'mensuelle':
          return 'Mensuelle'
        case 'annuelle':
          return 'Annuelle'
      }
    },

    handleNameReverse(name) {
      switch (name) {
        case 'Journalière':
          return 'journaliere'
        case 'Hebdomadaire':
          return 'hebdomadaire'
        case 'Mensuelle':
          return 'mensuelle'
        case 'Annuelle':
          return 'annuelle'
      }
    },
    loadRecurrences() {
      this.loading++

      return new Promise((resolve, reject) => {
        let url = import.meta.env.VITE_API_URL + '/recurrences'

        const config = {
          url: url,
          method: 'GET'
        }

        return axiosOverlayConnector(config)
          .then((response) => {
            this.recurrences = {
              Journalière: [],
              Hebdomadaire: [],
              Mensuelle: [],
              Annuelle: []
            }

            // Création de la répartition des récurrences par période
            // Au format : { 'Journalière': [recurrence1, recurrence2], ... }
            this.recurrences = response.data.reduce((acc, recurrence) => {
              const periodicite = this.handleName(recurrence.periodicite)
              acc[periodicite].push(recurrence)
              return acc
            }, this.recurrences)

            // Tri des récurrences en fonction de leur périodicité
            this.recurrences['Journalière'].sort((a, b) => a.id - b.id)
            this.recurrences['Hebdomadaire'].sort((a, b) => a.jourSemaine - b.jourSemaine)
            this.recurrences['Mensuelle'].sort((a, b) => a.jourMois - b.jourMois)
            this.recurrences['Annuelle'].sort((a, b) => a.jourAnnee.localeCompare(b.jourAnnee))

            // Suppression des périodes sans récurrences
            if (this.recurrences['Journalière'].length === 0) delete this.recurrences['Journalière']
            if (this.recurrences['Hebdomadaire'].length === 0)
              delete this.recurrences['Hebdomadaire']
            if (this.recurrences['Mensuelle'].length === 0) delete this.recurrences['Mensuelle']
            if (this.recurrences['Annuelle'].length === 0) delete this.recurrences['Annuelle']

            resolve()
          })
          .catch((error) => {
            // console.log(apiErrorParser(error))
            reject(error)
          })
          .finally(() => {
            this.loading--
          })
      })
    },

    addRecurrence(recurrenceData) {
      const userStore = useUserStore()

      this.loading++

      return new Promise((resolve, reject) => {
        let url = import.meta.env.VITE_API_URL + '/recurrences'

        const config = {
          url: url,
          method: 'POST',
          data: {
            ...recurrenceData,
            idCompte: userStore.idCompte
          }
        }

        return axiosOverlayConnector(config)
          .then(() => {
            this.loadRecurrences()
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            this.loading--
          })
      })
    },

    updateRecurrence(recurrenceData) {
      this.loading++

      return new Promise((resolve, reject) => {
        let url = import.meta.env.VITE_API_URL + '/recurrences/' + recurrenceData.id

        const config = {
          url: url,
          method: 'PUT',
          data: {
            ...recurrenceData
          }
        }

        return axiosOverlayConnector(config)
          .then(() => {
            this.loadRecurrences()
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            this.loading--
          })
      })
    },

    deleteRecurrence(idRecurrence) {
      this.loading++

      return new Promise((resolve, reject) => {
        let url = import.meta.env.VITE_API_URL + '/recurrences/' + idRecurrence

        const config = {
          url: url,
          method: 'DELETE'
        }

        return axiosOverlayConnector(config)
          .then(() => {
            this.loadRecurrences()
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            this.loading--
          })
      })
    }
  }
})
